import React, { useEffect, useState } from "react";

export const HeroSection = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => { setMounted(true); }, []);

  return (
    <>
      <section className="hero-wrapper">
        {/* === CONTENT === */}
        <div className="hero-content">

          {/* EYEBROW BADGE */}
          <div className="hero-badge">
            <span className="badge-dot" />
            AI Marketing · Built for Small Business Owners
          </div>

          {/* HEADLINE */}
          <div className="hero-title-container">
            <div className="hero-title-grid-bg" />
            <h1 className="hero-title">
              <span className="hero-title-primary">Run Your Business.</span>
              <br />
              <span className="hero-title-accent">We'll Grow It.</span>
            </h1>
          </div>

          {/* SUBHEADLINE */}
          <p className="hero-sub">
            <span className="brand-inline">Digital Trent</span> builds your complete
            30-day marketing plan, writes your social media posts, and tracks what's
            working — so you spend your time on customers, not content.
          </p>

          {/* ROI PROOF POINTS */}
          <div className="proof-row">
            <div className="proof-item">
              <div className="proof-icon-wrap">
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                  <path d="M2 8l4.5 4.5L14 3.5" stroke="#16a34a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span>30-day plan ready in minutes</span>
            </div>
            <div className="proof-item">
              <div className="proof-icon-wrap">
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                  <path d="M2 8l4.5 4.5L14 3.5" stroke="#16a34a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span>Posts written for your business</span>
            </div>
            <div className="proof-item">
              <div className="proof-icon-wrap">
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                  <path d="M2 8l4.5 4.5L14 3.5" stroke="#16a34a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span>More customers, less effort</span>
            </div>
          </div>

          {/* CTA */}
          <div className="cta-group">
            <a href="/auth/signup" className="hero-btn-primary">
              <span>Get My Free Marketing Plan</span>
              <svg className="btn-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 3L11 8L6 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <p className="cta-trust">Free 14-day trial · No credit card · Cancel anytime</p>
          </div>

        </div>
      </section>

      <style>{`
        * { box-sizing: border-box; }

        /* ── WRAPPER — original gradient + animated grid ── */
        .hero-wrapper {
          width: 100%;
          min-height: 100vh;
          background: linear-gradient(to bottom, #ffffff 0%, #fafbfc 50%, #f5f7fa 100%);
          padding: 150px 20px 80px;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          position: relative;
          overflow: hidden;
          z-index: 1;
        }


        /* ── CONTENT ── */
        .hero-content {
          max-width: 760px;
          width: 100%;
          position: relative;
          z-index: 10;
          animation: fadeInUp 0.8s ease-out both;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(28px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ── EYEBROW BADGE ── */
        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 7px 16px;
          background: #f0f9ff;
          border: 1px solid #bae6fd;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 600;
          color: #0369a1;
          letter-spacing: 0.025em;
          margin-bottom: 30px;
          animation: fadeInUp 0.8s ease-out both;
        }

        .badge-dot {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #0ea5e9;
          flex-shrink: 0;
          animation: pulse 2s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50%       { opacity: 0.6; transform: scale(0.85); }
        }

        /* ── TITLE with localized grid behind it ── */
        .hero-title-container {
          position: relative;
          display: inline-block;
          margin-bottom: 24px;
        }

        .hero-title-grid-bg {
          position: absolute;
          top: 50%; left: 50%;
          transform: translate(-50%, -50%);
          width: 130%; height: 150%;
          background-image:
            linear-gradient(rgba(59, 130, 246, 0.3) 2px, transparent 2px),
            linear-gradient(90deg, rgba(59, 130, 246, 0.3) 2px, transparent 2px);
          background-size: 50px 50px;
          z-index: -1;
          pointer-events: none;
          mask-image: radial-gradient(ellipse 65% 55% at center, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.5) 35%, transparent 65%);
          -webkit-mask-image: radial-gradient(ellipse 65% 55% at center, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.5) 35%, transparent 65%);
          animation: gridPulse 4s ease-in-out infinite;
        }

        @keyframes gridPulse {
          0%, 100% { opacity: 0.6; }
          50%       { opacity: 0.9; }
        }

        .hero-title {
          position: relative;
          font-size: clamp(2.4rem, 6vw, 4rem);
          line-height: 1.0;
          letter-spacing: -0.03em;
          margin: 0;
          animation: fadeInUp 0.8s ease-out 0.1s both;
        }

        /* "Run Your Business." — bold, authoritative, slate-800 */
        .hero-title-primary {
          font-weight: 800;
          color: #1e293b;
          display: block;
        }

        /* "We'll Grow It." — blue→green gradient */
        .hero-title-accent {
          display: block;
          font-weight: 500;
          background: linear-gradient(to right, #3b82f6, #10b981);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          letter-spacing: -0.02em;
          margin-top: 0;
          line-height: 1.0;
        }

        /* "Digital Trent" inline brand pill — blue→green gradient bg */
        .brand-inline {
          display: inline-block;
          background: linear-gradient(to right, rgba(59,130,246,0.18), rgba(16,185,129,0.18));
          border: 1px solid rgba(59,130,246,0.35);
          border-radius: 5px;
          padding: 1px 9px 2px;
          font-weight: 700;
          color: #1e40af;
          font-size: 0.95em;
          vertical-align: baseline;
        }

        /* ── SUBHEADLINE ── */
        .hero-sub {
          font-size: clamp(1rem, 2.2vw, 1.15rem);
          font-weight: 400;
          color: #475569;
          line-height: 1.75;
          max-width: 580px;
          margin: 0 auto 32px;
          animation: fadeInUp 0.8s ease-out 0.2s both;
        }

        /* ── PROOF POINTS ── */
        .proof-row {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 24px;
          flex-wrap: wrap;
          margin-bottom: 36px;
          animation: fadeInUp 0.8s ease-out 0.25s both;
        }

        .proof-item {
          display: flex;
          align-items: center;
          gap: 7px;
          font-size: 13px;
          font-weight: 500;
          color: #1e293b;
        }

        .proof-icon-wrap {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #dcfce7;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        /* ── CTA ── */
        .cta-group {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
          animation: fadeInUp 0.8s ease-out 0.3s both;
        }

        .hero-btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(135deg, #2563eb, #1d4ed8);
          color: #ffffff;
          padding: 15px 32px;
          border-radius: 10px;
          font-size: 15px;
          font-weight: 600;
          text-decoration: none;
          transition: all 0.25s ease;
          box-shadow: 0 4px 16px rgba(37, 99, 235, 0.32);
          position: relative;
          overflow: hidden;
        }

        .hero-btn-primary::before {
          content: '';
          position: absolute;
          top: 0; left: -100%;
          width: 100%; height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.18), transparent);
          transition: left 0.5s;
        }

        .hero-btn-primary:hover::before { left: 100%; }

        .hero-btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(37, 99, 235, 0.4);
        }

        .btn-arrow {
          transition: transform 0.25s ease;
        }

        .hero-btn-primary:hover .btn-arrow {
          transform: translateX(3px);
        }

        .cta-trust {
          font-size: 12px;
          color: #94a3b8;
          margin: 0;
        }

        /* ── RESPONSIVE — MOBILE ── */
        @media (max-width: 768px) {
          .hero-wrapper {
            padding: 120px 16px 60px;
            min-height: auto;
            align-items: flex-start;
          }

          .hero-title { font-size: 2rem; }

          .hero-sub {
            font-size: 1rem;
            margin-bottom: 24px;
          }

          .proof-row {
            flex-direction: column;
            gap: 12px;
            margin-bottom: 28px;
          }

          .proof-item { font-size: 13px; }

          .hero-btn-primary {
            padding: 14px 28px;
            font-size: 14px;
            width: 100%;
            max-width: 300px;
            justify-content: center;
          }
        }

        @media (max-width: 480px) {
          .hero-wrapper { padding: 100px 14px 50px; }
          .hero-title   { font-size: 1.8rem; }
        }

        @media (min-width: 769px) and (max-width: 1024px) {
          .hero-wrapper { padding: 130px 24px 70px; }
          .hero-title   { font-size: 2.8rem; }
        }

        @media (min-width: 1440px) {
          .hero-wrapper  { padding: 160px 20px 100px; }
          .hero-content  { max-width: 820px; }
        }
      `}</style>
    </>
  );
};

export default HeroSection;
